import {
  I18nProvider,
  initI18nInstance,
} from '@gasbi/shared/common/providers/I18nProvider';
import { ErrorBoundary } from '@gasbi/shared/web/components/ErrorBoundary';
import { createRoot } from 'react-dom/client';

import { App } from './App';

async function bootstrap() {
  // The shared namespaces only (the chat components read `chat`); the app has no texts of its own yet
  const i18n = await initI18nInstance();
  createRoot(document.getElementById('root')!).render(
    <ErrorBoundary>
      <I18nProvider instance={i18n}>
        <App />
      </I18nProvider>
    </ErrorBoundary>,
  );
}

bootstrap();

